export enum FunctionalRolesEnum {
  QUICK_REPORTS = 'Quick_Reports',
  ANALYTICS = 'RTW_Module',
  CLU = 'Claim_Overview'
}
